import {
  Component,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppMessageService } from '../../../../../shared/services/app-message/app-message.service';

@Component({
  selector: 'app-file-upload-dialog',
  templateUrl: './add-file.modal.component.html',
  styleUrls: ['./add-file.modal.component.scss'],
})
export class FileUploadDialogComponent {
  displayUploadDialog: boolean = false;
  fileDescription: string = '';

  @Output() fileAdded = new EventEmitter<any>(); // Emit file data to parent component
  @ViewChild('fileInput', { static: false }) fileInput: ElementRef;
  @ViewChild('selectedFileDesc', { static: false })
  fileDescSelector: ElementRef;

  fileError: string | null = null;
  uploadedFile: any;
  annoucementId: number | null = null;

  uploadedPrevFiles: any[] = [];

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly messageService: AppMessageService,
    private readonly translate: TranslateService
  ) {}

  resetFormValues() {
    this.cdr.detectChanges();
  }

  async initialize(annoucementId: number | null, prevFiles: any[]) {
    this.annoucementId = annoucementId;
    this.uploadedPrevFiles = prevFiles;
    this.openDialog();
  }

  onFileUpload(event: any) {
    this.uploadedFile = event.files[0]; // Store the uploaded file
  }

  save() {
    if (this.uploadedFile) {
      const element = this.uploadedFile;
      const newItem = {
        file: element?.file,
        fileName: element?.fileName,
        fileExt: element?.fileExt,
        filePath: 'announcement',
        fileDescription: this.fileDescription,
      };
      this.fileAdded.emit(newItem);
      this.displayUploadDialog = false;
      this.fileError = '';
      this.resetFormFields(); // Reset fields after saving
    } else {
      this.messageService.errorToast(
        this.translate.instant('common.error'),
        this.translate.instant('Lütfen eksik alanları doldurunuz')
      );
    }
  }

  openDialog() {
    this.displayUploadDialog = true;
  }

  cancelDialog() {
    this.displayUploadDialog = false;
  }

  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      const file = input.files[0];
      const fileDescValue = this.fileDescSelector.nativeElement.value;
      const fileData = {
        createdAt: new Date().toLocaleDateString(),
        file: file,
        fileExt: file.type,
        fileDescription: fileDescValue,
        fileName: file.name,
      };

      this.uploadedFile = fileData;
      this.fileError = '';

      if (file.size > 5 * 1024 * 1024) {
        // 5 MB limit
        this.fileError = 'File size should be less than 5 MB';
        this.uploadedFile = null;
      }
    }
  }

  resetFormFields() {
    // Reset the fields
    this.fileDescription = '';
    this.uploadedFile = null;
    this.fileError = null; // Reset any error messages
    if (this.fileInput) {
      this.fileInput.nativeElement.value = ''; // Reset file input
    }
  }
}
